<modal-layout-right [modalTitle]="'More Information'|translate">
    <div modalBody>

        <product-view-media [source]="content.product"
                            [isUpsellPreviewVariant]="true" />
        @if (content.product.data?.sale_banner) {
        <product-sale-banner [product]="content.product"
                             [content]="content"
                             [fullWidth]="true" />
        }
        <!-- product name -->
        <div class="w-12 m-t-6">
            <h1 class="w-11">
                @if (content.product.displayBrandCode) {
                <span class="block s1 w-11 col-11">{{asString(content.product.brandCode) | titlecase}}&nbsp;</span>
                }
                @if (content.product.displayRangeCode) {
                <span class="block s1">{{asString(content.product.rangeCode) | titlecase}}&nbsp;</span>
                }
                @if (content.product.data?.product_outline || parentProduct.data?.product_outline) {
                <span class="block p1">{{content.product.data.product_outline
                    || parentProduct.data.product_outline}}&nbsp;</span>
                }
            </h1>
        </div>
        <div class="m-t-1 m-b-1 flex flex-justify-between">
            <!-- product price -->
            <product-view-price [product]="content.product"
                                class="m-t-3 m-t-4-s block"></product-view-price>
            <!-- reviews summary -->
            @if (content.product.canDisplayReviews) {
            <reviews-io-rating class="m-t-2 block"
                               [product]="content.product"></reviews-io-rating>
            }
        </div>
        <!-- configurable options -->
        @if (content.product.parent.isConfigurable) {
        <product-view-configurable-options class="m-t-6 block"
                                           [product]="content.product"
                                           [noCrossellLink]="true"
                                           [preselectSingles]="true"
                                           [upsellVariant]="true"
                                           (selectionChange)="onSelectionChange($event.data)"
                                           (crossellProductClick)="onCrossellProductClick($event)"
                                           (init)="onProductConfigurablesInit($event)">
        </product-view-configurable-options>
        }
        @if (displayColorCrossSells) {
        <product-view-crosssell-products-color [upsellVariant]="true"
                                               [product]="content.product"
                                               (productClick)="onCrossellProductClick($event)"
                                               [ngClass]="{'m-b-1' : content.product.familySamples?.length}"
                                               class="block m-t-5"></product-view-crosssell-products-color>
        }

        <product-view-samples [product]="content.product"
                              class="block m-b-6-s"></product-view-samples>

        @if (!!content.product.data?.long_description) {
        <div class="m-t-6-s m-t-8">
            <h3 class="s2">{{'Product Description' | translate }}</h3>
            <div class="p2 col-11 m-t-2"
                 [innerHTML]="content.product.data?.long_description">
            </div>
        </div>
        }
        <product-view-dimensions-and-details [product]="content.product"
                                             [rightView]="true"
                                             [icons]="content.content.dimensions_icons"
                                             [topAttributes]="content.content.dimensionsTopAttributes"
                                             [sections]="content.content.dimensions_sections">
        </product-view-dimensions-and-details>
    </div>
    <div modalFooter>
        <button class="button w-12"
                [attr.aria-label]="'Confirm' | translate"
                (click)="confirm()"
                type="button">
            {{'Confirm' | translate }}
        </button>
    </div>
</modal-layout-right>